import { Form } from 'antd'
import { TCustomFormProps } from './types'
import { useMemo } from 'react'
import { notification } from '../../Notification'
import { Options } from 'scroll-into-view-if-needed'
import { VALIDATION_MESSAGES } from '../../../constants'

export const Default = <T extends object>({
  children,
  showErrorMsgOnFail,
  enableScrollToError,
  ...props
}: TCustomFormProps<T>): JSX.Element => {
  // default predefined error message
  const onFinishFailed = useMemo(
    () =>
      showErrorMsgOnFail
        ? () =>
            notification.error({
              message: VALIDATION_MESSAGES.FORM_VALIDATION_ERROR
            })
        : undefined,
    [showErrorMsgOnFail]
  )

  // default scroll behavior to be reused everywhere
  const scrollToFirstError = useMemo(
    () =>
      enableScrollToError
        ? ({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          } as Options)
        : undefined,
    [enableScrollToError]
  )

  return (
    <Form<T>
      scrollToFirstError={scrollToFirstError}
      onFinishFailed={onFinishFailed}
      {...props}
    >
      {children}
    </Form>
  )
}
